import React from "react";
import { Link } from "react-router-dom";
import { Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Form } from "shards-react";
import { TiEdit } from "react-icons/ti";
import moment from "moment";
import { FcList } from "react-icons/fc";
import ConversionDataService from "../../services/conversions.service";
import { ToastContainer } from "react-toastify";

class DetailConversions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      conversionDetails: {},
    };
  }

  componentDidMount() {
    if (this.props.conversionId) this.retrieveConversionDetails();
  }

  retrieveConversionDetails() {
    ConversionDataService.get(this.props.conversionId).then((response) => {
      this.setState({ conversionDetails: response.data.data[0] });
    });
  }

  render() {
    const { RetailerId, PROD_CODE, PROD_NAME, UOM, Conversion, isConversionFound } =
      this.state.conversionDetails;
    const { conversionId } = this.props;

    return (
      <div>
        <Card small className="mb-4">
          <CardHeader className="border-bottom">
            <h6 className="m-0">Conversion Details
              <Link className="btn btn-primary ml-4" to={"/conversion/view"}>
                <FcList /> View All
              </Link>
            </h6>
          </CardHeader>
          <ListGroup flush>
            <ListGroupItem className="">
              <Form>
                <Row form>
                  {/* First Name */}
                  <Col md="12" className="form-group">
                    <Row className="form-group-row">
                      <Col className="form-label" md="3">
                        <label htmlFor="actualBaseValue">Retailer ID</label>
                      </Col>
                      <Col className="form-field" md="9">
                        {RetailerId}
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-label" md="3">
                        <label htmlFor="convertedValue">Product Code</label>
                      </Col>
                      <Col className="form-field" md="9">
                        {PROD_CODE}
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-label" md="3">
                        <label htmlFor="createdByName">Product Name</label>
                      </Col>
                      <Col className="form-field" md="9">
                        {PROD_NAME}
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-label" md="3">
                        <label htmlFor="createdAt">UOM</label>
                      </Col>
                      <Col className="form-field" md="9">
                        {UOM}
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-label" md="3">
                        <label htmlFor="modifiedByName">Conversion</label>
                      </Col>
                      <Col className="form-field" md="9">
                        {Conversion}
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-label" md="3">
                        <label htmlFor="modifiedAt">Conversion Found</label>
                      </Col>
                      <Col className="form-field" md="9">
                        {isConversionFound}
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-button" md="4">
                        <Link className="btn btn-primary" to={"/conversion/" + conversionId + "/edit"}>
                          <TiEdit /> Edit Conversion
                        </Link>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </ListGroupItem>
          </ListGroup>
        </Card>
        <ToastContainer />
      </div>
    );
  }
}

export default DetailConversions;
